import React, { useEffect } from "react";
import { Heart, Users, Globe, Smile } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Navbar from "./navbar";
import Footer from "./footer";

const AboutUs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const storedLanguage = localStorage.getItem('selectedLanguage');
  //   if (!storedLanguage) {
  //     navigate('/');
  //   }
  // }, [navigate]);

  return (
    <>
 <div className="fixed inset-0 bg-gradient-to-br from-orange-100 via-violet-200 to-indigo-300 bg-[length:400%_400%] animate-gradient -z-10" />
      
      <div>
      <Navbar />

      <div className="max-w-7xl mx-auto px-4 md:px-10 py-16">
        {/* Title */}
        <h1 className="text-3xl md:text-4xl font-bold text-center text-[#d35400] text-center mt-16 mb-12 md:mb-16">
          {t("about.title")}
        </h1>

        {/* Introduction */}
        <section className="mb-16 text-center">
          <p className="text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">
            {t("about.welcome")}
          </p>
        </section>

        {/* Mission & Vision */}
        <section className="mb-20">
          <h2 className="text-2xl md:text-3xl font-bold text-[#d35400] mb-6">
            {t("about.missionVision")}
          </h2>
          <p className="text-md md:text-lg leading-relaxed max-w-4xl">
            {t("about.mission")}
            <br />
            <br />
            {t("about.vision")}
          </p>
        </section>

        {/* Why Choose Us */}
        <section className="mb-20">
          <h2 className="text-2xl md:text-3xl font-bold text-[#d35400] mb-6">
            {t("about.whyChoose")}
          </h2>
          <div className="grid gap-6 sm:grid-cols-2">
            {[
              {
                key: "verifiedProfiles",
                icon: <Heart className="text-[#d35400]" size={36} />,
              },
              {
                key: "communityFocused",
                icon: <Users className="text-[#d35400]" size={36} />,
              },
              {
                key: "globalReach",
                icon: <Globe className="text-[#d35400]" size={36} />,
              },
              {
                key: "personalizedSupport",
                icon: <Smile className="text-[#d35400]" size={36} />,
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md flex gap-4 items-start hover:shadow-xl transition-shadow duration-300 group"
              >
                <div className="transform group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                <div>
                  <h3 className="font-semibold text-lg mb-2">
                    {t(`about.features.${item.key}.title`)}
                  </h3>
                  <p>{t(`about.features.${item.key}.desc`)}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Core Values */}
        <section className="mb-20">
          <h2 className="text-2xl md:text-3xl font-bold text-[#d35400] mb-6">
            {t("about.coreValues")}
          </h2>
          <p className="mb-4 max-w-3xl">{t("about.coreValuesText")}</p>
          <ul className="list-disc list-inside space-y-2 text-md md:text-lg">
            {["integrity", "customerCentric", "innovation"].map(
              (key, index) => (
                <li key={index}>{t(`about.valuesList.${key}`)}</li>
              ),
            )}
          </ul>
        </section>

        {/* Testimonials */}
        <section className="mb-20">
          <h2 className="text-2xl md:text-3xl font-bold text-[#d35400] mb-6">
            {t("about.testimonials")}
          </h2>
          {["testimonial1", "testimonial2", "testimonial3"].map(
            (key, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition duration-300 max-w-2xl mx-auto mb-4"
              >
                <p className="text-lg">
                  "{t(`about.testimonialsData.${key}.text`)}"
                </p>
                <p className="mt-3 text-right text-sm text-gray-600 italic">
                  – {t(`about.testimonialsData.${key}.author`)}
                </p>
              </div>
            ),
          )}
        </section>

        {/* Call to Action */}
        <section className="text-center mt-20">
          <h2 className="text-3xl md:text-4xl font-bold text-[#d35400] mb-4">
            {t("about.ctaTitle")}
          </h2>
          <p className="mb-6 text-md md:text-lg text-gray-700">
            {t("about.ctaText")}
          </p>
        </section>
      </div>

      
    </div>
    <Footer />
    </>
  );
};

export default AboutUs;
